export const getCurrencyFromString = string => {
  const valueArray = string.split('$');
  const startOfRange = valueArray[1];

  if (!startOfRange) return -1;

  return startOfRange.length >= 9
    ? parseInt(startOfRange, 10) * 1000
    : parseInt(startOfRange, 10);
};

export const getFilterSelectionsTotalCount = filters => {
  return filters.reduce((acc, filter) => {
    const totalSelections = filter.value ? filter.value.length : 0;

    acc = acc + totalSelections;

    return acc;

  }, 0);
};

export const getErrorMessage = error => {
  if (error) {
    return error.message || error.type || JSON.stringify(error);
  }
};
